import { TextInput, type TextInputSize } from "@/shared/foundation/primitives";

import { isValueless, type StringComparator } from "../FilterSchema";

interface StringValueInputProps {
  comparator: StringComparator;
  value: string[];
  onChange: (next: string[]) => void;
  /**
   * Take focus on mount. The filter menu wants it; an editor that renders
   * several inputs at once does not. @default true
   */
  autoFocus?: boolean;
  /** Marks the input invalid, for an error shown beside it. */
  invalid?: boolean;
  /** Field size, on the `TextInput` scale. @default "md" */
  size?: TextInputSize;
}

export function StringValueInput({
  comparator,
  value,
  onChange,
  autoFocus = true,
  invalid = false,
  size = "md",
}: StringValueInputProps) {
  const valueless = isValueless(comparator);

  if (valueless) {
    return null;
  }

  return (
    <TextInput
      autoFocus={autoFocus}
      aria-invalid={invalid || undefined}
      size={size}
      placeholder="Enter value..."
      value={value[0] ?? ""}
      onChange={(event) => {
        onChange([event.target.value]);
      }}
    />
  );
}
